<template>
  <img src="../../../static/images/competency.png" alt="">
</template>

<script>
    export default {
        name: "competency"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/User/competency.vue